import * as types from '../actions/ScandphotosActionTypes';
import InitialState from './ScandphotosInitialState';

export default function photographerBookingReducer(
    state: any = InitialState.calendar,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.SCANDPHOTOS_GET_PHOTOGRAPHERBOOKING_SUCCESS:
            return {
                ...state,
                calendar: action.result.calendar,
                orderInfo: action.result.orderInfo,
                bookableOnlyBySE360: action.result.bookableOnlyBySE360
            };
        case types.SCANDPHOTOS_UPDATE_PHOTOGRAPHERBOOKING_SUCCESS:
            return {
                ...state,
                calendar: action.result.calendar,
                orderInfo: action.result.orderInfo,
                bookableOnlyBySE360: action.result.bookableOnlyBySE360
            };
        case types.SCANDPHOTOS_GET_ORDERINFO_SUCCESS:
            return {
                ...state,
                orderInfo: action.result,
                bookableOnlyBySE360: action.result.bookableOnlyBySE360
            };
        default:
            return state;
    }
}
